"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.osFinder = exports.OSName = void 0;
var OSName;
(function (OSName) {
    OSName["Windows"] = "Windows";
    OSName["MacOS"] = "MacOS";
    OSName["Linux"] = "Linux";
    OSName["IOS"] = "IOS";
    OSName["Android"] = "Android";
    OSName["UnknownOS"] = "UnknownOS";
})(OSName || (exports.OSName = OSName = {}));
var find = function () {
    var userAgent = navigator.userAgent.toLowerCase();
    if (/win/i.test(userAgent)) {
        return OSName.Windows;
    }
    else if (/mac/i.test(userAgent)) {
        return OSName.MacOS;
    }
    else if (/linux/i.test(userAgent)) {
        return OSName.Linux;
    }
    else if (/iphone|ipad|ipod/i.test(userAgent)) {
        return OSName.IOS;
    }
    else if (/android/i.test(userAgent)) {
        return OSName.Android;
    }
    else {
        return OSName.UnknownOS;
    }
};
exports.osFinder = { find: find };
//# sourceMappingURL=os-finder.js.map